import React from "react";
import {connect} from "react-redux";
import queryString from "query-string";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Card, Col, Container, Modal, Row} from "react-bootstrap";
import {productoActions} from "../../../_actions";
import {ErrorMessage, history, LoadingBoton} from "../../../_helpers";
import {NavBarLateral} from "../../includes";
import authService from "../../../_services/cart/authService";
import userServiceTs from "../../../_services/cart/userService";
import http from '../../../_services/cart/http.service';
import alertService from "../../../_services/cart/alert.service";
import ReactSwitch from "react-switch";
import { Formik, Form, Field } from "formik";
import { userService } from "../../../_services";
import * as Yup from "yup";

import Select from "react-select";
import { busquedaActions } from "../../../_actions/busqueda.actions";

const _ = require("lodash");

class FormEditarTipo extends React.Component {

    state = {
        grabando: false
    }


    componentDidMount() {
       const { filtros } = this.props;
       
       this.props.traerFiltros();
    }

    render() {

        const {objeto, show, handleClose, tipo, filtros} = this.props;

        const customSelect = {
            control: (provided) => ({
              // class attribute : class=" css-i32vvf-control"
              ...provided,
              background: "transparent",
              display: "flex",
              flexWrap: "nowrap",
              borderColor: "hsl(0deg 0% 80%);",
              width: "100%",
              height: "48px",
            }),
          };

       

        let shape = {    
            nombre: Yup.string()
            .required("Requerido")
            .min(2, "El Nombre debe tener al menos 2 caracteres")
            .max(100, "Demasiado largo")            
        }

        if(tipo === "MODELO"){
            shape.marca= Yup.object({
                    id: Yup.string().required("Requerido").label("Marca"),
                  })
        }

        if(tipo === "VERSION"){
            shape.modelo= Yup.object({
                    id: Yup.string().required("Requerido").label("Modelo"),
                  })

            if(objeto !==undefined){
                objeto.marca = filtros?.marcas?.filter(it=>it.id == objeto.modelo.marca.id)[0];
            }
        }
    
        const validationSchema = Yup.object().shape(shape);

        let inic = _.clone(objeto??{nombre:''});

        return (
            <><Modal
                        show={show}
                        onHide={handleClose}
                        backdrop="static"
                    >
                        <Modal.Header className="bg-cielo " closeButton>
                            <Modal.Title>
                                <i className="fas fa-paper-plane"></i> Editar {tipo} {objeto?.name}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="th_uva">                        

                        <Formik
                            enableReinitialize={true}
                            initialValues={inic}
                            validationSchema={validationSchema}
                            onSubmit={(values) => {
                            this.setState({ grabando: true });
                            http.post('api/admin/tipos/crear/'+tipo, values).then(
                                (data) => {
                                    this.setState({ grabando: false });
                                    alertService.msg(tipo + " " + values.nombre + 
                                        " actualizada exitosamente."
                                    );                                   
                                },
                                (error) => {
                                    this.setState({ grabando: false });
                                    alertService.error(error);
                                }
                            );
                            }}
                        >
                            {({ errors, touched, values, setFieldValue}) => (
                            <Form>
                                <Row>
                                 <Col sm={12}>
                                    <label htmlFor="nombre">
                                        Nombre
                                    </label>
                                    <ErrorMessage name={`nombre`} />
                                    <div className="input-group mb-2">
                                        <Field name="nombre" type={"text"} />
                                    </div>
                                </Col>
                                {(tipo === 'MODELO' || tipo === 'VERSION') && 
                                <Col sm={12}>
                                    <label htmlFor="marca">
                                    Marca
                                    </label>
                                    <div className="input-group mb-2 w-100">   
                                    <Select
                                        className="w-100"
                                        styles={customSelect}
                                        value={
                                        filtros?.marcas
                                            ? filtros.marcas.find(
                                                (option) => option.id === values.marca?.id
                                            )
                                            : ""
                                        }
                                        getOptionLabel={(option) => `${option.nombre}`}
                                        getOptionValue={(option) => option.id}
                                        onChange={(so) => {
                                        setFieldValue(`marca.id`, so ? so.id : "");
                                        }}
                                        isSearchable={true}
                                        placeholder="Seleccione una"
                                        options={filtros?.marcas}
                                    />
                                    <ErrorMessage name={`marca.id`} />

                                    </div>
                                </Col>}

                                {tipo === 'VERSION' &&<Col sm={12}>
                                    <label htmlFor="modelo">
                                    Modelo
                                    </label>
                                    <div className="input-group mb-2">
                                        <Select
                                        className="w-100"
                                            styles={customSelect}
                                            value={
                                            filtros?.modelos
                                                ? filtros.modelos.find(
                                                    (option) => option.id === values.modelo?.id
                                                )
                                                : ""
                                            }
                                            getOptionLabel={(option) => `${option.nombre}`}
                                            getOptionValue={(option) => option.id}
                                            onChange={(so) => {
                                            setFieldValue(`modelo.id`, so ? so.id : "");
                                            }}
                                            isSearchable={true}
                                            placeholder="Seleccione una"
                                            options={filtros?.modelos.filter(
                                            (it) => it.marca.id === values.marca?.id
                                            )}
                                        />
                                    </div>
                                </Col>}

                                <Col sm={12}>
                                <label className="switch__container">
                                    <span>¿Activo?</span>
                                    <br />
                                    <ReactSwitch
                                        onChange={(event) => {
                                            setFieldValue(`active`, event);
                                        }}
                                        checked={values.active}
                                        onColor="#FF962E"
                                    />
                                    </label>
                                </Col>
                                </Row>
                                <div className="justify-content-center mt-5 p-3 row border-top bg-light">
                                    
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={this.state.grabando}
                                    >
                                        <i className="icon-floppy"></i> Grabar
                                        <LoadingBoton grabando={this.state.grabando} />
                                    </button>
                                </div>
                            </Form>
                            )}
                        </Formik>
                        </Modal.Body>
                    </Modal>
            </>
        );
    }
}

function mapState(state) {
    const { filtros } = state.busqueda;
    return { filtros };
}

const actionCreators = {
    traerFiltros: busquedaActions.traerFiltros
};

const connectedFormEditarTipo = connect(mapState, actionCreators)(FormEditarTipo);
export {connectedFormEditarTipo as FormEditarTipo};
